import { Injectable } from '@angular/core';
import { AppError } from '@models/appError';
import { ToastService } from './_toast/_toast.service';

@Injectable({ providedIn: 'root' })
export class ApiHttpErrorService {
  constructor(private toastService: ToastService) {}

  public handle(error: AppError, toastDuration: number = null): void {
    // Can handle specific status codes here
    this.toastService.showError(error.formatErrorForToast(), toastDuration);
  }
}
